import PocketBase from 'pocketbase';

// URL till PocketBase-instansen (sätts via VITE_POCKETBASE_URL i .env).
// I Dokploy pekas env-variabeln mot den befintliga PocketBase-tjänsten.
const url = import.meta.env.VITE_POCKETBASE_URL ?? 'http://localhost:8090';

export const pb = new PocketBase(url);

// baseUrl används av sidor som behöver bygga egna URL:er mot PB (t.ex.
// Screener, som undviker SDK:ns filter-serialisering för att inte skicka
// filter=undefined till PB).
export const pbBaseUrl = url;

// Auth-state överlever sidladdningar i localStorage (PocketBase default).
// Vid 401-logout kan man lyssna på pb.authStore.onChange.

/**
 * Hämta unika värden för ett textfält i en PB-collection. Används av
 * FilterPanel för att populera dropdowns (sector, country) med de
 * värden som faktiskt finns i databasen.
 *
 * Hämtar bara `field`-projection och filtrerar bort null/tomma. PB har
 * ingen inbyggd DISTINCT-operator så vi deduplikerar i klienten.
 */
export async function fetchDistinctValues(
  collection: string,
  field: string,
): Promise<string[]> {
  const url = `${pbBaseUrl}/api/collections/${collection}/records?perPage=500&fields=${encodeURIComponent(field)}&filter=${encodeURIComponent(`${field} != null && ${field} != ""`)}`;
  const res = await fetch(url);
  if (!res.ok) {
    throw new Error(`HTTP ${res.status}: ${await res.text().catch(() => res.statusText)}`);
  }
  const data = (await res.json()) as { items: Array<Record<string, string>> };
  const seen = new Set<string>();
  for (const item of data.items) {
    const v = item[field];
    if (v && v.trim()) seen.add(v);
  }
  return Array.from(seen).sort();
}